import { takeLatest, call, put, all } from 'redux-saga/effects';

import { ApiResponse, postApi } from 'services/_api';

import { PATH_DETRAN_CRV, CHANNEL } from 'services/_path';

import { ReducerAction } from 'store/modules/types';

import { Types, IPTREOERequest } from './types';

import { consultarPTREOESuccess, consultarPTREOEFailure } from './actions';

function* consultarPTREOERequest(request: ReducerAction) {
	const { payload }: { payload: IPTREOERequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`resumo-veiculo/${CHANNEL}/pesquisa/ocorrencia-escolhida`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultarPTREOESuccess(response));
	} else if (response.error) {
		yield put(consultarPTREOEFailure(response));
	}
}

export default all([takeLatest(Types.PTREOE_REQUEST, consultarPTREOERequest)]);
